import { isMplPreApprovalOffer } from 'shared/lib';

import type { TPreApprovalControlOffer } from './types';

export const getOfferSteps = (offer: TPreApprovalControlOffer) => {
  if (isMplPreApprovalOffer(offer)) {
    return offer.steps || [];
  }

  return offer.preApprovalOffer?.steps || [];
};

export const getOfferBankName = (offer: TPreApprovalControlOffer) =>
  isMplPreApprovalOffer(offer) ? offer.organizationName : offer.bankName;

export const getOfferIsReferral = (offer: TPreApprovalControlOffer) => {
  if (isMplPreApprovalOffer(offer)) {
    return offer.isReferral;
  }

  return !!offer.additionalInfo?.isReferral;
};
